import classNames from "classnames";
import { HTMLAttributes, PropsWithChildren } from "react";
import Col, { ColProps } from "../../divSpecializations/Col";

type PdfRowProps = { 
    className?: string;
    alignTop?: boolean;
    useFlex?: boolean;

} & PropsWithChildren<HTMLAttributes<HTMLDivElement>>;

const PdfRow = ({
    className, 
    alignTop = true,
    useFlex = true,
    ...props
}: PdfRowProps) => {
    return (
        <div 
            className={classNames(useFlex ? "flex-container-row" : "row", alignTop && "align-items-start", className)} 
            {...props}
        >
            {props.children}
        </div>
    );
}

export default Object.assign(
    PdfRow, {
        Col: ({width=2, ...props}: ColProps) => <Col width={width} {...props}>{props.children}</Col>
    }
);